import { render, staticRenderFns } from "./PasswordChallenge.vue?vue&type=template&id=4d0de516&scoped=true"
import script from "./PasswordChallenge.vue?vue&type=script&lang=js"
export * from "./PasswordChallenge.vue?vue&type=script&lang=js"
import style0 from "./PasswordChallenge.vue?vue&type=style&index=0&id=4d0de516&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0de516",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d0de516')) {
      api.createRecord('4d0de516', component.options)
    } else {
      api.reload('4d0de516', component.options)
    }
    module.hot.accept("./PasswordChallenge.vue?vue&type=template&id=4d0de516&scoped=true", function () {
      api.rerender('4d0de516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messages/PasswordChallenge.vue"
export default component.exports